/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dizzy_Spare_Fish_AcceptInputs */

const fr_dizzy_spare_fish_accept = /** @type {(inputs: Dizzy_Spare_Fish_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours avec places limitées — classés du moins au plus rempli`)
};

/**

* @param {Dizzy_Spare_Fish_AcceptInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const dizzy_spare_fish_accept = /** @type {((inputs?: Dizzy_Spare_Fish_AcceptInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dizzy_Spare_Fish_AcceptInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_dizzy_spare_fish_accept(inputs)
});